import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useLoading from "./useLoading";
import { authHeader } from "../utils/Constants";

const useCategory = ({ url, resultField }) => {
  const [category, setCategory] = useState([]);

  const token = JSON.parse(localStorage.getItem("token"));

  const [loader, showLoader, hideLoader] = useLoading();

  const fetchCategory = async () => {
    if (token) {
      try {
        showLoader();
        const res = await axios.get(url, {
          //headers: authHeader,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "X-Requested-With": "XMLHttpRequest",
          },
        });
        if (res.status === 200) {
          setCategory(res.data[resultField]);
          hideLoader();
        } else {
          console.log("error", res.status);
        }
      } catch (error) {
        console.log("category API catch error: ", error);
        if (error.response.status === 502) {
          hideLoader();
          toast.error(error.response.data.message, {
            position: "bottom-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });
        }
      }
    }
  };

  return [category, loader, fetchCategory];
};

export default useCategory;
